// src/router/index.js
import Vue from 'vue'
import Router from 'vue-router'

// ===== 用户侧（你原有的）=====
import { hasValidSession } from '@/store/session'

// ===== 管理端（新增）=====
import { hasValidAdminSession } from '@/admin/session'

const LoginPage = () => import(/* webpackChunkName: "user-auth" */ '@/views/Login.vue')
const ServerSelectPage = () => import(/* webpackChunkName: "user-servers" */ '@/views/ServerSelect.vue')
const PersonalInfoPage = () => import(/* webpackChunkName: "user-profile" */ '@/views/PersonalInfo.vue')
const AdminLogin = () => import('@/views/admin/AdminLogin.vue')
const AdminLayout = () => import('@/views/admin/AdminLayout.vue')
const AdminStats = () => import('@/views/admin/pages/StatsPage.vue')
const AdminServers = () => import('@/views/admin/pages/ServersPage.vue')
const AdminCategories = () => import('@/views/admin/pages/CategoriesPage.vue')
const AdminGoods = () => import('@/views/admin/pages/GoodsPage.vue')
const AdminOrders = () => import('@/views/admin/pages/OrdersPage.vue')
const AdminUsers = () => import('@/views/admin/pages/UsersPage.vue')
const AdminWallets = () => import('@/views/admin/pages/WalletsPage.vue')
const AdminLedger = () => import('@/views/admin/pages/LedgerPage.vue')
const AdminCarReplace = () => import('@/views/admin/pages/CarReplaceReview.vue')
const AdminSystemConfig = () => import('@/views/admin/pages/SystemConfigPage.vue')
const AdminCdkManage = () => import('@/views/admin/pages/CdkManagePage.vue')
const AdminBuildingWipe = () => import('@/views/admin/pages/BuildingWipePage.vue')
const AdminArchiveInheritance = () => import('@/views/admin/pages/ArchiveInheritancePage.vue')

Vue.use(Router)

const router = new Router({
  mode: 'hash',
  routes: [
    { path: '/', redirect: '/servers' },
    { path: '/login', component: LoginPage, meta: { public: true, title: '幸存者登录' } },
    { path: '/servers', component: ServerSelectPage, meta: { public: true, title: '选择服务器' } },
    { path: '/shop/:serverCode', name: 'Shop', component: () => import(/* webpackChunkName: "user-shop" */ '@/views/Shop.vue'), props: true, meta: { requiresAuth: true, title: '物资补给站' } },
    { path: '/profile', component: PersonalInfoPage, meta: { requiresAuth: true, title: '个人中心' } },

    // ===== 管理端 =====
    { path: '/admin/login', component: AdminLogin, meta: { public: true, admin: true, title: '管理员登录' } },
    {
      path: '/admin',
      component: AdminLayout,
      meta: { admin: true },
      redirect: '/admin/stats',
      children: [
        { path: 'stats', component: AdminStats, meta: { admin: true, title: '经营概览' } },
        { path: 'servers', component: AdminServers, meta: { admin: true, title: '服务器管理' } },
        { path: 'categories', component: AdminCategories, meta: { admin: true, title: '商品分类' } },
        { path: 'goods', component: AdminGoods, meta: { admin: true, title: '商品管理' } },
        { path: 'orders', component: AdminOrders, meta: { admin: true, title: '订单管理' } },
        { path: 'cdk', component: AdminCdkManage, meta: { admin: true, title: 'CDK 管理' } },
        { path: 'users', component: AdminUsers, meta: { admin: true, title: '用户管理' } },
        { path: 'wallets', component: AdminWallets, meta: { admin: true, title: '钱包管理' } },
        { path: 'ledger', component: AdminLedger, meta: { admin: true, title: '钱包流水' } },
        { path: 'archive-inheritance', component: AdminArchiveInheritance, meta: { admin: true, title: '结档继承' } },
        { path: 'building-wipe', component: AdminBuildingWipe, meta: { admin: true, title: '建筑清档' } },
        { path: 'system-config', component: AdminSystemConfig, meta: { admin: true, title: '系统配置' } },
        { path: 'replace', component: AdminCarReplace, meta: { admin: true, title: '补车审核' } }
      ]
    }
  ]
})

// 守卫：先处理 admin，再走用户侧
router.beforeEach(function (to, from, next) {
  if (to.matched.some(r => r.meta && r.meta.admin)) {
    const adminLoggedIn = hasValidAdminSession()
    const isPublic = to.matched.some(r => r.meta && r.meta.public)
    if (to.path === '/admin/login' && adminLoggedIn) return next('/admin')
    if (!isPublic && !adminLoggedIn) {
      return next({ path: '/admin/login', query: { redirect: to.fullPath } })
    }
    return next()
  }

  const loggedIn = hasValidSession()
  const requiresAuth = to.matched.some(r => r.meta && r.meta.requiresAuth)

  if (to.path === '/') return next('/servers')
  if (to.path === '/login' && loggedIn) return next('/servers')
  if (requiresAuth && !loggedIn) return next({ path: '/login', query: { redirect: to.fullPath } })
  next()
})

router.afterEach(function (to) {
  const title = to.matched.slice().reverse().find(record => record.meta && record.meta.title)
  document.title = title ? `${title.meta.title} · DayZ Shop` : 'DayZ Shop'
})

export default router
